<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <p class="text-muted font-13 mb-4"></p>
                        <div class="row mb-md-2">
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_length" class="dataTables_length">
                                    <label class="d-inline-flex align-items-center">
                                        Show&nbsp;
                                        <b-form-select
                                                v-model="perPage"
                                                size="sm"
                                                :options="pageOptions">
                                        </b-form-select>&nbsp;entries
                                    </label>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Search:
                                        <b-form-input
                                                v-model="filter"
                                                type="search"
                                                placeholder="Search..."
                                                class="form-control form-control-sm ml-2">
                                        </b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0">
                            <b-table
                                    ref="companiesTable"
                                    :items="companiesData"
                                    :busy.sync="isBusy"
                                    :fields="fields"
                                    responsive="sm"
                                    :per-page="perPage"
                                    :current-page="currentPage"
                                    :sort-by.sync="sortBy"
                                    :sort-desc.sync="sortDesc"
                                    :filter="filter"
                                    :filter-included-fields="filterOn">

                                <template v-slot:cell(id)="row">
                                    <a href="javascript: void(0);"
                                       class="text-body font-weight-bold"
                                    >{{row.item.id}}</a>
                                </template>

                                <template v-slot:cell(company)="row">
                                    {{row.item.company.name}}
                                </template>

                                <template v-slot:cell(action)="row">
                                    <b-button :id="row.item.id" variant="primary"
                                              type="button" class="btn btn-blue" @click="companyDetails(row.item)">
                                        <i class="mdi mdi-eye"></i>
                                    </b-button>
                                    <b-button :id="row.item.id" variant="primary"
                                              type="button" class="btn btn-blue" @click="assignProduct(row.item)">
                                        <i class="mdi mdi-check"></i>
                                    </b-button>
                                    <b-button :id="row.item.id" variant="primary"
                                              type="button" class="btn btn-blue" @click="assignDiscount(row.item)">
                                        <i class="mdi mdi-percent"></i>
                                    </b-button>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination
                                                v-model="currentPage"
                                                :total-rows="rows"
                                                :per-page="perPage"
                                                @input =" pageChange(currentPage);">
                                        </b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="remark-modal" ref="remark" size="lg" title="Description" title-class="font-18">
            <p>{{ remarkDetail}}</p>
            <b-button id="alert-toast" variant="primary"
                      type="button" class="btn btn-blue" @click="checkStatus">
                <i class="mdi mdi-eye"></i>
            </b-button>
        </b-modal>
    </Layout>
</template>

<script>
  import appConfig from '@src/app.config'
  import Layout from '@layouts/main'
  import PageHeader from '@components/page-header'

  import { companiesMethods } from '@state/helpers'


  /**
   * Advanced table component
   */
  export default {
    page: {
      title: 'Corporates',
      meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
      return {
        corporates: [],
        title: 'Corporates',
        items: [
          {
            text: '99Gift',
            href: '/',
          },
          {
            text: 'Companies',
            href: '/',
          },
          {
            text: 'Corporate',
            active: true,
          },
        ],
        isBusy: false,
        remarkDetail: null,
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        filter: null,
        filterOn: [],
        sortBy: 'id',
        sortDesc: false,
        selectedRow: null,
        fields: [
          { key: 'id', label: 'Id', sortable: true },
          { key: 'company_id', label: 'Company Id' },
          { key: 'name', label: 'Company Name' },
          { key: 'contact_person', label: 'POC Name' },
          { key: 'contact_no', label: 'POC Number' },
          { key: 'email', label: 'Email' },
          { key: 'telephone', label: 'Telephone' },
          { key: 'action',  label: 'Action', sortable: false },
        ],
      }
    },
    computed: {
      /**
       * Total no. of records
       */
      rows() {
        return this.totalRows
      },
    },
    mounted() {

    },
    methods: {
      ...companiesMethods,

      /**
       * Search the table data with search input
       */
      async companiesData(context) {

        const { sortBy, sortDesc , perPage, currentPage } = context;

        this.currentPage = currentPage;
        this.rowsPerPage = perPage;

        this.isBusy = true

        try{
          const { success, message, data: { result } } = await this.fetchCorporates({
            page: this.currentPage,
            rowsPerPage: this.perPage,
            sortBy,
            descending: sortDesc

          });

          if(!success) throw Error(message)

          this.totalRows = result.totalCount
          this.corporates =  result.data
        }
        catch (e){

          this.orders = []
          this.appToast('Error', e.message || 'Error while operating', 'danger')
        }

        this.isBusy = false
        return this.corporates;
      },

      async pageChange(page){

        this.currentPage = page
      },

      companyDetails(data){
        this.$router.push(`/company/company-details/${data.id}`)
      },

      assignProduct(data){
        this.$router.push(`/company/assign-product/${data.company_id}/${data.id}`)
      },

      assignDiscount(data){
        this.$router.push(`/company/assign-discount/${data.company_id}/${data.id}`)
      },
    },
  }
</script>